module.exports = __webpack_public_path__ + "static/fonts/CoHeadlineCorp-Regular.9a9e0c6.eot";